export const WESTERN_CONFERENCE = {
  GUARDS: [
    'shai-gilgeous-alexander-19980712-2024-limited-357',
    'devin-booker-19961030-2024-limited-329',
    'anthony-edwards-20010805-2024-limited-371',
    'stephen-curry-19880314-2024-limited-384',
    'deaaron-fox-19971220-2024-limited-403',
    'ja-morant-19990810-2024-limited-298',
    'kyrie-irving-19920323-2024-limited-384',
    'norman-powell-19930525-2024-limited-386',
    'james-harden-19890826-2024-limited-404',
    'jamal-murray-19970223-2024-limited-365',
    'luka-doncic-19990228-2024-limited-11',
  ],
  FWD: [
    'nikola-jokic-19950219-2024-limited-306',
    'anthony-davis-19930311-2024-limited-362',
    'victor-wembanyama-20040104-2024-limited-315',
    'domantas-sabonis-19960503-2024-limited-369',
    'lebron-james-19841230-2024-limited-431',
    'kevin-durant-19880929-2024-limited-326',
    'lauri-markkanen-19970522-2024-limited-380',
    'draymond-green-19900304-2024-limited-153',
    'alperen-sengun-20020725-2024-limited-380',
    'jaren-jackson-jr-19990915-2024-limited-416',
    'jalen-williams-20010414-2024-limited-420',
    'julius-randle-19941129-2024-limited-408',
  ],
};

export const EASTERN_CONFERENCE = {
  GUARDS: [
    'lamelo-ball-20010822-2024-limited-342',
    'cade-cunningham-20010925-2024-limited-418',
    'damian-lillard-19900715-2024-limited-361',
    'tyrese-haliburton-20000229-2024-limited-365',
    'trae-young-19980919-2024-limited-347',
    'jalen-brunson-19960831-2024-limited-368',
    'donovan-mitchell-19960907-2024-limited-369',
    'tyrese-maxey-20001104-2024-limited-382',
    'darius-garland-20000126-2024-limited-401',
    'tyler-herro-20000120-2024-limited-70',
    'jalen-suggs-20010603-2024-limited-381',
  ],
  FWD: [
    'giannis-antetokounmpo-19941206-2024-limited-84',
    'jayson-tatum-19980303-2024-limited-393',
    'karl-anthony-towns-19951115-2024-limited-250',
    'bam-adebayo-19970718-2024-limited-424',
    'jimmy-butler-19890914-2024-limited-323',
    'franz-wagner-20010827-2024-limited-382',
    'jaylen-brown-19961024-2024-limited-379',
    'jalen-johnson-20011218-2024-limited-417',
    'pascal-siakam-19940402-2024-limited-365',
    'evan-mobley-20010618-2024-limited-389',
    'cameron-johnson-19960303-2024-limited-370',
    'nikola-vucevic-19901024-2024-limited-445',
  ],
};

export const ALL_STAR = {
  GUARDS: [
    'shai-gilgeous-alexander-19980712-2024-limited-357',
    'anthony-edwards-20010805-2024-limited-371',
    'stephen-curry-19880314-2024-limited-384',
    'james-harden-19890826-2024-limited-404',
    'cade-cunningham-20010925-2024-limited-418',
    'damian-lillard-19900715-2024-limited-361',
    'jalen-brunson-19960831-2024-limited-368',
    'donovan-mitchell-19960907-2024-limited-369',
    'darius-garland-20000126-2024-limited-401',
    'tyler-herro-20000120-2024-limited-70',
  ],
  FWD: [
    'nikola-jokic-19950219-2024-limited-306',
    'anthony-davis-19930311-2024-limited-362',
    'victor-wembanyama-20040104-2024-limited-315',
    'lebron-james-19841230-2024-limited-431',
    'kevin-durant-19880929-2024-limited-326',
    'alperen-sengun-20020725-2024-limited-380',
    'jaren-jackson-jr-19990915-2024-limited-416',
    'jalen-williams-20010414-2024-limited-420',
    'giannis-antetokounmpo-19941206-2024-limited-84',
    'jayson-tatum-19980303-2024-limited-393',
    'karl-anthony-towns-19951115-2024-limited-250',
    'jaylen-brown-19961024-2024-limited-379',
    'pascal-siakam-19940402-2024-limited-365',
    'evan-mobley-20010618-2024-limited-389',
  ],
};
